define('ResetPassword.View', [
    'PageType.Base.View',
    'ResetPassword.Form.View',
    'ResetPassword.Model',
    'Utils',
    'jQuery',
    'resetpassword_edit.tpl'
], function (
    PageTypeBaseView,
    ResetPasswordFormView,
    ResetPasswordModel,
    Utils,
    jQuery,
    resetpasswordEditTpl
) {
    'use strict';

    return PageTypeBaseView.PageTypeBaseView.extend({
        template: resetpasswordEditTpl,

        initialize: function initialize() {
            this.model = new ResetPasswordModel();
            this.identity = this.getIdentity();
            this.isLoading = true;
            this.isTokenValid = true;
        },

        getIdentity: function getIdentity() {
            var queryString = window.location.search ? window.location.search.slice(1) : '';
            var routerArguments = this.options.routerArguments && this.options.routerArguments[0] ?
                this.options.routerArguments[0] : '';
            var params = Utils.parseUrlOptions(queryString || routerArguments);

            return {
                email: params.email || '',
                internalid: params.internalid || '',
                recordtype: params.recordtype || '',
                token: params.token || ''
            };
        },

        beforeShowContent: function beforeShowContent() {
            var self = this;

            // PageType can populate routerArguments after initialize, so read the URL here.
            this.identity = this.getIdentity();

            if (!this.identity.email || !this.identity.internalid || !this.identity.token) {
                this.isLoading = false;
                return jQuery.Deferred().resolve();
            }

            return this.model.validateToken(this.identity).then(function (response) {
                self.isTokenValid = Boolean(response && response.valid);
            }, function () {
                self.isTokenValid = false;
            }).always(function () {
                self.isLoading = false;
            });
        },

        getChildViews: function(){
            return { 
                'ResetPassword.Form.View': 
                    function resetPasswordFormView() {
                        return new ResetPasswordFormView({
                        model: this.model,
                        identity: this.identity
                    });
                }
            }
        },

        getContext: function getContext() {
            return {
                isLoading: this.isLoading,
                isTokenValid: this.isTokenValid
            };
        }
    });
});
